import { RewardItemT } from "components/molecules/LoyaltyListRewards/types";
import { StatusRank } from "components/atoms/LoyaltyRankStatus/types";
import {
  HEIGHT_FROM_LAST_REWARD_RANK_TO_FIRST_REWARD_LEVEL,
  HEIGHT_FROM_TOP_TO_REWARDS_RANK,
  HEIGHT_REWARD,
} from "./constants";

export const getHeightProgress = (
  userExperience: number,
  rewardsRank: RewardItemT[],
  levels: Array<{
    title: string;
    status: StatusRank;
    rewards: RewardItemT[];
    requirement: number;
    nextRequirement: number;
  }>,
  isOpen: boolean,
  isLastRank: boolean,
  isFirstRank?: boolean,
) => {
  if (
    !levels ||
    levels.length === 0 ||
    userExperience < levels[0].requirement
  ) {
    return "0%";
  }

  if (!isOpen && userExperience >= levels[0].requirement) {
    const lastIndexLevel = levels.length - 1;
    if (isLastRank && userExperience >= levels[lastIndexLevel].requirement) {
      return "100%";
    }

    const nextRankExperience = levels[levels.length - 1].nextRequirement;
    const startExperienceRank = levels[0].requirement;

    if (userExperience >= nextRankExperience) {
      return "100%";
    }

    const progress = nextRankExperience - startExperienceRank;
    const userExp = userExperience - startExperienceRank;
    const result = (userExp / progress) * 100;

    if (isFirstRank) {
      return "1%";
    }

    return result > 30 ? `${result}%` : "30%";
  }

  let result = 0;

  result +=
    HEIGHT_FROM_TOP_TO_REWARDS_RANK +
    rewardsRank.length * HEIGHT_REWARD +
    HEIGHT_FROM_LAST_REWARD_RANK_TO_FIRST_REWARD_LEVEL;

  return `${result}px`;
};
